import { render, staticRenderFns } from "./AddGeneralMemberView.vue?vue&type=template&id=ff0b7072&scoped=true"
import script from "./AddGeneralMemberView.vue?vue&type=script&lang=js"
export * from "./AddGeneralMemberView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff0b7072",
  null
  
)

export default component.exports